import { ScreenWaveLoader } from '@/shared'
import loadable from '@loadable/component'

export const AnonymousRoutesLazy = loadable(() => import('./AnonymousRoutes'), {
  fallback: <ScreenWaveLoader />
})
